import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQueries } from '@tanstack/react-query';
import { RefundsApiAdapter } from '../adapters/RefundsApiAdapter';
import { Filters } from '../models/Filters';
import { Service } from '../services/Service';

export type RefundStatusCounts = Record<'all' | 'pending' | 'liquidated', number>;

const statuses = [
  { key: 'all', status: '' },
  { key: 'pending', status: 'pending' },
  { key: 'liquidated', status: 'liquidated' },
] as const;

export const useRefundsStatusCounts = (filters: Filters = {}) => {
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new RefundsApiAdapter(httpClient);
  const service = new Service(apiAdapter);

  const results = useQueries({
    queries: statuses.map(({ key, status }) => ({
      queryKey: ['refunds-status-count', key, filters],
      queryFn: () =>
        service.getPaginated({
          ...filters,
          status,
          page: 1,
          per_page: 1,
        }),
      staleTime: 2 * 60 * 1000,
      gcTime: 5 * 60 * 1000,
    })),
  });

  const counts = statuses.reduce<RefundStatusCounts>(
    (acc, { key }, index) => {
      acc[key] = results[index]?.data?.total ?? 0;
      return acc;
    },
    { all: 0, pending: 0, liquidated: 0 },
  );

  return {
    counts,
    isLoading: results.some((result) => result.isLoading),
  };
};
